import types from './types';

const {
  FETCH_SUPERSET_REPORT_DETAILS_BEGIN,
  FETCH_SUPERSET_REPORT_DETAILS_SUCCESS,
  FETCH_SUPERSET_REPORT_DETAILS_ERROR,
  FETCH_SUPERSET_TOKEN_BEGIN,
  FETCH_SUPERSET_TOKEN_SUCCESS,
  FETCH_SUPERSET_TOKEN_ERROR,
} = types

const supersetReportReducer = (state = {
  report: null,
  loading: true,
  token: null,
  filter: null,
}, action) => {
  switch (action.type) {
    case FETCH_SUPERSET_REPORT_DETAILS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_SUPERSET_REPORT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        report: action.payload.report,
      };
    case FETCH_SUPERSET_REPORT_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case FETCH_SUPERSET_TOKEN_BEGIN:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_SUPERSET_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        token: action.payload.token,
        filters: action.payload.filters
      };
    case FETCH_SUPERSET_TOKEN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default supersetReportReducer;
